// extracted by mini-css-extract-plugin
export var option = "_2v-0";
export var optionSelected = "_2v-1 _2v-0";
export var optionUnselected = "_2v-2 _2v-0";
export var radioInner = "_2v-5";
export var radioOuter = "_2v-3";
export var radioOuterSelected = "_2v-4 _2v-3";